// Interfaces pour typer les données partagées

export interface Relation {
  schema_type: 'system' | 'custom';
  schema: string;
  field: string;
}

export interface Field {
  id: number; // unique client-side ID
  name: string;
  label: string;
  type: AvailableTypeEnum;
  required: boolean;
  unique_key: boolean;
  description?: string;
  default?: any; // can be string, number, boolean, date, null
  relation?: Relation | null;
  options?: string[];
}

export interface SystemSchemaField {
  name: string;
  label: string;
  type: string;
}

export interface SystemSchema {
  name: string;
  label: string;
  fields: SystemSchemaField[];
}

// Interface FK pour l'état interne du tableau des relations
export interface ForeignKeyRow extends Relation {
  id: number;
  localField: string; // Nom du champ local (source)
  isEditing?: boolean;
  originalData?: Omit<ForeignKeyRow, 'id' | 'isEditing' | 'originalData'>; // Pour annuler
  selectedTargetSchema: { type: 'system' | 'custom'; name: string }[] | null; // Pour MultiSelect
  isNew?: boolean;
}

// Options MultiSelect pour la sélection de la table cible

// Available types for customData fields
export enum AvailableTypeEnum {
  BOOL = 'bool',
  TEXT = 'text',
  LONGTEXT = 'longtext',
  NUMBER = 'number',
  DECIMAL = 'decimal',
  LIST = 'list',
  DATE = 'date',
  DATETIME = 'datetime',
  JSON = 'json',
  GEOLOCATION = 'geolocation',
}

// Types eligible for unique key (all indexable types — excludes longtext and json)
export const UNIQUE_KEY_ELIGIBLE_TYPES: AvailableTypeEnum[] = [
  AvailableTypeEnum.TEXT,
  AvailableTypeEnum.NUMBER,
  AvailableTypeEnum.DECIMAL,
  AvailableTypeEnum.LIST,
  AvailableTypeEnum.BOOL,
  AvailableTypeEnum.DATE,
  AvailableTypeEnum.DATETIME,
];

export interface TargetSchemaOption {
  label: string;
  value: { type: 'system' | 'custom'; name: string };
}
export interface TargetSchemaGroup {
  groupLabel: string;
  items: TargetSchemaOption[];
}

// Définition d'un override de champ système par un champ custom
export interface Override {
  customField: string; // nom du champ custom
  systemField: string; // nom du champ système
  systemSchema: string; // nom du schéma système (ex: 'products')
  priority?: number; // priorité de l'override (1 = plus haute priorité)
}

export interface OverrideItem {
  id: string;
  id_custom_data_definition: string | null; // null pour nouvelles créations
  custom_field_name: string;
  priority: number;
}
